// src/components/SessionTimeoutDialog.jsx
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

export default function SessionTimeoutDialog({ open, secondsLeft, onStay, onSignOut }) {
    return (
        <Dialog open={open} maxWidth="xs" fullWidth>
            <DialogTitle>Session timing out</DialogTitle>
            <DialogContent>
                <Typography>
                    Your session will end in <strong>{secondsLeft}</strong> seconds due to inactivity.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onSignOut}>Sign out</Button>
                <Button variant="contained" onClick={onStay}>Stay signed in</Button>
            </DialogActions>
        </Dialog>
    );
}
